<template>
  <CustomDashboard
    :user-id="userId"
    :dashboard="dashboard"
    :dashboard-owners="dashboardOwners"
    :export-data="exportData"
  />
</template>

<script>
import axios from 'axios'
import CustomDashboard from '@/components/CustomDashboard'
import { getData, createInListString } from '@/helpers/custom-dashboard'

export default {
  components: {
    CustomDashboard
  },

  props: {
    userId: Number
  },

  data () {
    return {
      context: 'dashboards',
      dashboard: DASHBOARD,
      queryLimit: 100000, // Limit for the number of results returned.
      dataTruncMap: {
        Daily: 'DAY',
        Monthly: 'MONTH',
        Weekly: 'WEEK'
      },
      dashboardId: 58,
      dashboardOwners: ''
    }
  },

  computed: {
    // TODO: making these computed properties to be dynamic created
    growthQuery () {
      let query = `SELECT CALENDAR_DATE, REGION, ${this.dashboard.widgets[this.dashboard.widgets[0].columnSelection].value}, WOW_${this.dashboard.widgets[this.dashboard.widgets[0].columnSelection].value} FROM ${this.dashboard.dataSource} WHERE `

      this.dashboard.widgets[0].filters.forEach(index => {
        const widget = this.dashboard.widgets[index]
        if (['checkbox', 'select-multiple'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} IN (${createInListString(widget.value)}) AND `
        } else if (['select', 'input'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} = '${widget.value}' AND `
        }
      })
      query += `CALENDAR_DATE between dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, -${this.dashboard.widgets[9].value - 1}, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) and dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, 0, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) ORDER BY CALENDAR_DATE, REGION`
      return query
    },

    ultilizationQuery () {
      let query = `SELECT CALENDAR_DATE, REGION, ${this.dashboard.widgets[this.dashboard.widgets[1].columnSelection].value}, WOW_${this.dashboard.widgets[this.dashboard.widgets[1].columnSelection].value} FROM ${this.dashboard.dataSource} WHERE `

      this.dashboard.widgets[1].filters.forEach(index => {
        const widget = this.dashboard.widgets[index]
        if (['checkbox', 'select-multiple'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} IN (${createInListString(widget.value)}) AND `
        } else if (['select', 'input'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} = '${widget.value}' AND `
        }
      })
      query += `CALENDAR_DATE between dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, -${this.dashboard.widgets[9].value - 1}, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) and dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, 0, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) ORDER BY CALENDAR_DATE, REGION`
      return query
    },

    fleetHealthQuery () {
      let query = `SELECT CALENDAR_DATE, REGION, ${this.dashboard.widgets[this.dashboard.widgets[2].columnSelection].value}, WOW_${this.dashboard.widgets[this.dashboard.widgets[2].columnSelection].value} FROM ${this.dashboard.dataSource} WHERE `

      this.dashboard.widgets[1].filters.forEach(index => {
        const widget = this.dashboard.widgets[index]
        if (['checkbox', 'select-multiple'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} IN (${createInListString(widget.value)}) AND `
        } else if (['select', 'input'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} = '${widget.value}' AND `
        }
      })
      query += `CALENDAR_DATE between dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, -${this.dashboard.widgets[9].value - 1}, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) and dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, 0, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) ORDER BY CALENDAR_DATE, REGION`
      return query
    },

    riderQuery () {
      let query = `SELECT CALENDAR_DATE, REGION, ${this.dashboard.widgets[this.dashboard.widgets[3].columnSelection].value}, WOW_${this.dashboard.widgets[this.dashboard.widgets[3].columnSelection].value} FROM ${this.dashboard.dataSource} WHERE `

      this.dashboard.widgets[1].filters.forEach(index => {
        const widget = this.dashboard.widgets[index]
        if (['checkbox', 'select-multiple'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} IN (${createInListString(widget.value)}) AND `
        } else if (['select', 'input'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} = '${widget.value}' AND `
        }
      })
      query += `CALENDAR_DATE between dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, -${this.dashboard.widgets[9].value - 1}, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) and dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, 0, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) ORDER BY CALENDAR_DATE, REGION`
      return query
    },

    juicerQuery () {
      let query = `SELECT CALENDAR_DATE, REGION, ${this.dashboard.widgets[this.dashboard.widgets[4].columnSelection].value}, WOW_${this.dashboard.widgets[this.dashboard.widgets[4].columnSelection].value} FROM ${this.dashboard.dataSource} WHERE `

      this.dashboard.widgets[1].filters.forEach(index => {
        const widget = this.dashboard.widgets[index]
        if (['checkbox', 'select-multiple'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} IN (${createInListString(widget.value)}) AND `
        } else if (['select', 'input'].includes(widget.metadata.type)) {
          query += `${widget.metadata.name} = '${widget.value}' AND `
        }
      })
      query += `CALENDAR_DATE between dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, -${this.dashboard.widgets[9].value - 1}, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) and dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, 0, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) ORDER BY CALENDAR_DATE, REGION`
      return query
    },

    bottomlineQuery () {
      const selectedMetricColumn = this.dashboard.widgets[this.dashboard.widgets[27].columnSelection].value || ''
      let query = `SELECT a.CALENDAR_DATE, a.REGION, a.${selectedMetricColumn}, `

      if (selectedMetricColumn.endsWith('_PCT_GROSS')) {
        // The non percentage version of the selected metric column
        // e.g.: JUICER_LABOR_COST_PCT_GROSS -> JUICER_LABOR_COST
        const nonPercentageMetricColumn = selectedMetricColumn.replace(new RegExp('_PCT_GROSS$'), '')

        query += `
          case WHEN b.${selectedMetricColumn} is not null AND b.${selectedMetricColumn} <> 0 THEN (a.${selectedMetricColumn} - b.${selectedMetricColumn}) / b.${selectedMetricColumn} ELSE null END as WOW_${selectedMetricColumn}
          FROM
          (
            SELECT *, case WHEN GROSS_REVENUE is not null AND GROSS_REVENUE <> 0 THEN ${nonPercentageMetricColumn} / GROSS_REVENUE ELSE null end as ${selectedMetricColumn}
            FROM ${this.dashboard.dataSource}
          ) as a,
          (
            SELECT *, case WHEN GROSS_REVENUE is not null AND GROSS_REVENUE <> 0 THEN ${nonPercentageMetricColumn} / GROSS_REVENUE ELSE null end as ${selectedMetricColumn}
            FROM ${this.dashboard.dataSource}
          ) as b
        `
      } else {
        query += `a.WOW_${selectedMetricColumn} FROM ${this.dashboard.dataSource} as a`
      }

      query += ' WHERE '

      this.dashboard.widgets[1].filters.forEach(index => {
        const widget = this.dashboard.widgets[index]
        if (['checkbox', 'select-multiple'].includes(widget.metadata.type)) {
          query += `a.${widget.metadata.name} IN (${createInListString(widget.value)}) AND `
        } else if (['select', 'input'].includes(widget.metadata.type)) {
          query += `a.${widget.metadata.name} = '${widget.value}' AND `
        }
      })
      query += `a.CALENDAR_DATE between dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, -${this.dashboard.widgets[9].value - 1}, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) and dateadd(${this.dataTruncMap[this.dashboard.widgets[5].value]}, 0, date_trunc(${this.dataTruncMap[this.dashboard.widgets[5].value]}, current_date)) `

      if (selectedMetricColumn.endsWith('PCT_GROSS')) {
        query += `
          AND a.PERIOD = b.PERIOD and a.CORE_REGION = b.CORE_REGION AND a.COUNTRY = b.COUNTRY AND a.REGION = b.REGION AND a.PRODUCT = b.PRODUCT
          AND b.CALENDAR_DATE = dateadd(WEEK, -1, a.CALENDAR_DATE)
        `
      }

      query += 'ORDER BY a.CALENDAR_DATE, a.REGION;'
      return query
    },

    exportData () {
      return this.dashboard.widgets.filter(widget => ['table', 'table-by-value'].includes(widget.metadata.type))
        .map(widget => ({ name: widget.metadata.title, data: widget.value }))
    },

    coreRegionQuery () {
      return `SELECT DISTINCT CORE_REGION FROM ${this.dashboard.dataSource} WHERE 
        ${this.dashboard.widgets[32].metadata.name} IN (${createInListString(this.dashboard.widgets[32].value)}) ORDER BY CORE_REGION ASC`
    },

    countryQuery () {
      return `SELECT DISTINCT COUNTRY FROM ${this.dashboard.dataSource} WHERE 
        ${this.dashboard.widgets[6].metadata.name} IN (${createInListString(this.dashboard.widgets[6].value)}) ORDER BY COUNTRY ASC`
    },

    regionQuery () {
      return `SELECT DISTINCT REGION FROM ${this.dashboard.dataSource} WHERE 
        ${this.dashboard.widgets[7].metadata.name} IN (${createInListString(this.dashboard.widgets[7].value)}) ORDER BY REGION ASC`
    }
  },

  watch: {
    growthQuery (val) {
      this.dashboard.widgets[0].loading = true
      getData(val, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, val, 'growthQuery')
        if (result.data.error) {
          this.loading = false
          return
        }
        this.dashboard.widgets[0].value = Object.freeze(result.data.data)
        this.dashboard.widgets[0].loading = false
      })
    },

    ultilizationQuery (val) {
      this.dashboard.widgets[1].loading = true
      getData(val, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, val, 'ultilizationQuery')
        if (result.data.error) {
          this.dashboard.widgets[1].loading = false
          return
        }
        this.dashboard.widgets[1].value = Object.freeze(result.data.data)
        this.dashboard.widgets[1].loading = false
      })
    },

    fleetHealthQuery (val) {
      this.dashboard.widgets[2].loading = true
      getData(val, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, val, 'fleetHealthQuery')
        if (result.data.error) {
          this.dashboard.widgets[2].loading = false
          return
        }
        this.dashboard.widgets[2].value = Object.freeze(result.data.data)
        this.dashboard.widgets[2].loading = false
      })
    },

    riderQuery (val) {
      this.dashboard.widgets[3].loading = true
      getData(val, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, val, 'riderQuery')
        if (result.data.error) {
          this.dashboard.widgets[3].loading = false
          return
        }
        this.dashboard.widgets[3].value = Object.freeze(result.data.data)
        this.dashboard.widgets[3].loading = false
      })
    },

    juicerQuery (val) {
      this.dashboard.widgets[4].loading = true
      getData(val, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, val, 'juicerQuery')
        if (result.data.error) {
          this.dashboard.widgets[4].loading = false
          return
        }
        this.dashboard.widgets[4].value = Object.freeze(result.data.data)
        this.dashboard.widgets[4].loading = false
      })
    },

    bottomlineQuery (val) {
      this.dashboard.widgets[27].loading = true
      getData(val, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, val, 'bottomlineQuery')
        if (result.data.error) {
          this.dashboard.widgets[27].loading = false
          return
        }
        this.dashboard.widgets[27].value = Object.freeze(result.data.data)
        this.dashboard.widgets[27].loading = false
      })
    },

    dashboard: {
      deep: true,
      handler (dashboard) {
        const queryParams = dashboard.widgets
          .filter(widget => !['table', 'table-by-value', 'text', 'blank', 'report'].includes(widget.metadata.type))
          .reduce((acc, cur) => {
            acc[cur.metadata.name.toLowerCase()] = cur.value ? cur.value.toString() : ''
            return acc
          }, {})
        this.$router.replace({ name: this.$route.name, query: queryParams })
      }
    },

    coreRegionQuery (val) {
      this.dashboard.widgets[6].loading = true
      getData(val, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, val, 'coreRegionQuery')
        this.dashboard.widgets[6].options = Object.freeze(result.data.data.map(option => ({
          name: option[this.dashboard.widgets[6].metadata.name],
          value: option[this.dashboard.widgets[6].metadata.name]
        })))
        this.dashboard.widgets[6].value = Object.freeze(result.data.data.map(value => value[this.dashboard.widgets[6].metadata.name]))
        this.dashboard.widgets[6].loading = false
      })
    },

    countryQuery (val) {
      this.dashboard.widgets[7].loading = true
      getData(val, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, val, 'countryQuery')
        this.dashboard.widgets[7].options = Object.freeze(result.data.data.map(option => ({
          name: option[this.dashboard.widgets[7].metadata.name],
          value: option[this.dashboard.widgets[7].metadata.name]
        })))
        this.dashboard.widgets[7].value = Object.freeze(result.data.data.map(value => value[this.dashboard.widgets[7].metadata.name]))
        this.dashboard.widgets[7].loading = false
      })
    },

    regionQuery (val) {
      this.dashboard.widgets[8].loading = true
      getData(val, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, val, 'regionQuery')
        this.dashboard.widgets[8].options = Object.freeze(result.data.data.map(option => ({
          name: option[this.dashboard.widgets[8].metadata.name],
          value: option[this.dashboard.widgets[8].metadata.name]
        })))
        this.dashboard.widgets[8].value = Object.freeze(result.data.data.map(value => value[this.dashboard.widgets[8].metadata.name]))
        this.dashboard.widgets[8].loading = false
      })
    }
  },

  beforeCreate () {
    sessionStorage.setItem('context', 'dashboards')
  },

  created () {
    axios.get(`${process.env.VUE_APP_API_URI}/dashboards/${this.dashboardId}`)
      .then(response => {
        const dashboards = [...response.data]
        if (dashboards.length) {
          const sharedDashboard = { ...dashboards[0] }
          this.dashboardOwners = sharedDashboard.owners
        }
      })

    this.dashboard.widgets
      .filter(widget => ['table', 'table-by-value', 'text', 'blank', 'report'].every(value => value.indexOf(widget.metadata.type) < 0) && !widget.metadata.customField)
      .forEach(widget => getData(widget.query, this.queryLimit).then(result => {
        this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, widget.query, `${widget.metadata.name}Query`)
        if (['select', 'select-multiple'].includes(widget.metadata.type)) {
          return (widget.options = result.data.data.map(option => ({
            name: option[widget.metadata.name],
            value: option[widget.metadata.name]
          })))
        } else {
          return (widget.options = result.data.data.map(option => option[widget.metadata.name]))
        }
      }))

    // backfilling filters from URL params
    Object.keys(this.$route.query).map(param => {
      this.dashboard.widgets.forEach(filter => {
        if (filter.metadata.name && filter.metadata.name.toLowerCase() === param) {
          filter.value = this.$route.query[param]
        }
      })
    })

    // Make sure checkbox/select-multiple types are array not string
    this.dashboard.widgets.forEach(filter => {
      if (['checkbox', 'select-multiple'].includes(filter.metadata.type) && typeof filter.value === 'string') {
        filter.value = filter.value.split(',')
      }
    })

    this.dashboard.widgets[0].loading = true
    this.dashboard.widgets[1].loading = true
    this.dashboard.widgets[2].loading = true
    this.dashboard.widgets[3].loading = true
    this.dashboard.widgets[4].loading = true
    this.dashboard.widgets[27].loading = true

    getData(this.growthQuery, this.queryLimit).then(result => {
      this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, this.growthQuery, 'growthQuery')
      this.dashboard.widgets[0].value = Object.freeze(result.data.data)
      this.dashboard.widgets[0].loading = false
    })

    getData(this.ultilizationQuery, this.queryLimit).then(result => {
      this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, this.ultilizationQuery, 'ultilizationQuery')
      this.dashboard.widgets[1].value = Object.freeze(result.data.data)
      this.dashboard.widgets[1].loading = false
    })

    getData(this.fleetHealthQuery, this.queryLimit).then(result => {
      this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, this.fleetHealthQuery, 'fleetHealthQuery')
      this.dashboard.widgets[2].value = Object.freeze(result.data.data)
      this.dashboard.widgets[2].loading = false
    })

    getData(this.riderQuery, this.queryLimit).then(result => {
      this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, this.riderQuery, 'riderQuery')
      this.dashboard.widgets[3].value = Object.freeze(result.data.data)
      this.dashboard.widgets[3].loading = false
    })

    getData(this.juicerQuery, this.queryLimit).then(result => {
      this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, this.juicerQuery, 'juicerQuery')
      this.dashboard.widgets[4].value = Object.freeze(result.data.data)
      this.dashboard.widgets[4].loading = false
    })

    getData(this.bottomlineQuery, this.queryLimit).then(result => {
      this.$dashboardQueryLog(this.dashboard.title.name, result.data.queryId, this.bottomlineQuery, 'bottomlineQuery')
      this.dashboard.widgets[27].value = Object.freeze(result.data.data)
      this.dashboard.widgets[27].loading = false
    })

    this.$log('report_open', this.dashboard.title.name)
  }
}

// TODO: Change logic of regional filters for Metrics By Region to eliminate
// the need for hard-coded region filter values. These hard-coded values are suceptible
// to breaking the dashboard on initial load since region aggregations can change often
const DASHBOARD = {
  dashboardName: 'Local Ops Dashboard Overview',
  title: {
    name: 'Metrics By Region',
    isShown: false
  },
  dataSource: 'PRODUCTION_DATA.DM.LOCAL_OPS_MERGED_2_2',
  widgets: [{
    x: 1,
    y: 2,
    w: 19,
    h: 23,
    i: 0,
    metadata: {
      name: 'growthTable',
      title: 'Growth Table',
      type: 'table-by-value',
      customField: false,
      tableType: 'vertical'
    },
    styles: {
      leftColWidth: 150
    },
    filters: [5, 6, 7, 8, 10],
    columnSelection: 12,
    headerColumn: {
      name: 'CALENDAR_DATE',
      displayName: 'Calendar Date',
      format: 'date',
      fromFormat: 'YYYY-MM-DD',
      toFormat: 'MM/DD (ddd)',
      orderType: 'normal' // Order type: 'normal', 'asc', 'desc'
    },
    additionalHeaderColumn: {
      name: 'REGION',
      displayName: 'Region',
      format: 'string',
      orderType: 'normal'
    },
    columns: {
      COMPLETED_TRIPS: {
        displayName: 'Trips',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_COMPLETED_TRIPS',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_COMPLETED_TRIPS',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      GROSS_REVENUE: {
        displayName: 'Total Gross Bookings',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_GROSS_REVENUE',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_GROSS_REVENUE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      RECEIPT_REVENUE: {
        displayName: 'Total Charges to Riders',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_RECEIPT_REVENUE',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_RECEIPT_REVENUE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      REFUND_OF_GROSS_REVENUE: {
        displayName: 'Refund as % Gross Bookings',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_REFUND_OF_GROSS_REVENUE',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_REFUND_OF_GROSS_REVENUE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      REFERRAL_PROMOTION: {
        displayName: 'Referral Promotions Spend',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_REFERRAL_PROMOTION',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_REFERRAL_PROMOTION',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      REFERRAL_OF_GROSS_REVENUE: {
        displayName: 'Referral Promotions as % Gross Bookings',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_REFERRAL_OF_GROSS_REVENUE',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_REFERRAL_OF_GROSS_REVENUE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      LIFECYCLE_PROMOTION: {
        displayName: 'Lifecycle Promotions Spend',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_LIFECYCLE_PROMOTION',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_LIFECYCLE_PROMOTION',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      LIFECYCLE_OF_GROSS_REVENUE: {
        displayName: 'Lifecycle Promotions as % Gross Bookings',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_LIFECYCLE_OF_GROSS_REVENUE',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_LIFECYCLE_OF_GROSS_REVENUE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      SELF_SERVE_PROMOTION: {
        displayName: 'Self-serve Promotions Spend',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_SELF_SERVE_PROMOTION',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_SELF_SERVE_PROMOTION',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      SELF_SERVE_OF_GROSS_REVENUE: {
        displayName: 'Self-serve Promotions as % Gross Bookings',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_SELF_SERVE_OF_GROSS_REVENUE',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_SELF_SERVE_OF_GROSS_REVENUE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      UNCOLLECTED_OF_GROSS_REVENUE: {
        displayName: 'Failed Payment as % Gross Bookings',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_UNCOLLECTED_OF_GROSS_REVENUE',
          displayName: 'Avg. Growth Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_UNCOLLECTED_OF_GROSS_REVENUE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      }
    },
    value: []
  }, {
    x: 1,
    y: 27,
    w: 19,
    h: 23,
    i: 1,
    metadata: {
      name: 'utilizationTable',
      title: 'Utilization Table',
      type: 'table-by-value',
      customField: false,
      tableType: 'vertical',
      groupBy: 'REGION'
    },
    styles: {
      leftColWidth: 150
    },
    filters: [5, 6, 7, 8, 10],
    columnSelection: 13,
    headerColumn: {
      name: 'CALENDAR_DATE',
      displayName: 'Calendar Date',
      format: 'date',
      fromFormat: 'YYYY-MM-DD',
      toFormat: 'MM/DD (ddd)',
      orderType: 'normal'
    },
    additionalHeaderColumn: {
      name: 'REGION',
      displayName: 'Region',
      format: 'string',
      orderType: 'normal'
    },
    columns: {
      TVD: {
        displayName: 'TVD',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_TVD',
          displayName: 'Avg. Utilization Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_TVD',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      RPT: {
        displayName: 'RPT',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_RPT',
          displayName: 'Avg. Utilization Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_RPT',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      MEDIAN_DURATION_IN_MINS: {
        displayName: 'Median Trip Time (in minutes)',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_MEDIAN_DURATION_IN_MINS',
          displayName: 'Avg. Utilization Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_MEDIAN_DURATION_IN_MINS',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      MEDIAN_DISTANCE_IN_MILES: {
        displayName: 'Median Trip Distance (in miles)',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_MEDIAN_DISTANCE_IN_MILES',
          displayName: 'Avg. Utilization Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_MEDIAN_DISTANCE_IN_MILES',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      RVD: {
        displayName: 'RVD',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_RVD',
          displayName: 'Avg. Utilization Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_RVD',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      ZERO_RATE: {
        displayName: 'Zero Rate',
        format: 'decimal',
        precision: 1,
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_ZERO_RATE',
          displayName: 'Avg. Juicer Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_ZERO_RATE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      }
    },
    value: []
  }, {
    x: 1,
    y: 54,
    w: 19,
    h: 23,
    i: 2,
    metadata: {
      name: 'fleetMetricTable',
      title: 'Fleet Metric Table',
      type: 'table-by-value',
      customField: false,
      tableType: 'vertical',
      groupBy: 'REGION'
    },
    styles: {
      leftColWidth: 150
    },
    filters: [5, 6, 7, 8, 10],
    columnSelection: 14,
    headerColumn: {
      name: 'CALENDAR_DATE',
      displayName: 'Calendar Date',
      format: 'date',
      fromFormat: 'YYYY-MM-DD',
      toFormat: 'MM/DD (ddd)',
      orderType: 'normal'
    },
    additionalHeaderColumn: {
      name: 'REGION',
      displayName: 'Region',
      format: 'string',
      orderType: 'normal'
    },
    columns: {
      OPS_DECAY_RATE: {
        displayName: 'Decay Rate',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_OPS_DECAY_RATE',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_OPS_DECAY_RATE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      NET_OPS_DECAY_RATE: {
        displayName: 'Ops Decay Rate',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_NET_OPS_DECAY_RATE',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_NET_OPS_DECAY_RATE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      SICK_RATE: {
        displayName: 'Sick Rate',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_SICK_RATE',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_SICK_RATE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      CUMULATIVE_NET: {
        displayName: 'Total Vehicle Count',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_CUMULATIVE_NET',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_CUMULATIVE_NET',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      OPERATIONAL_VEHICLES: {
        displayName: 'Operational Vehicles',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_OPERATIONAL_VEHICLES',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_OPERATIONAL_VEHICLES',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      OPERATIONAL_SJ_SZ: {
        displayName: 'SJ/SZ',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_OPERATIONAL_SJ_SZ',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_OPERATIONAL_SJ_SZ',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      SICK: {
        displayName: '# of Sick Vehicles',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_SICK',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_SICK',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      DECAYED: {
        displayName: '# of Decayed Vehicles',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_DECAYED',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_DECAYED',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      OPS_REVIVED: {
        displayName: '# of Ops Revived Vehicles',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_OPS_REVIVED',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_OPS_REVIVED',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      }
    },
    value: []
  }, {
    x: 1,
    y: 81,
    w: 19,
    h: 23,
    i: 3,
    metadata: {
      name: 'ridersMetricTable',
      title: 'Riders MetricTable',
      type: 'table-by-value',
      customField: false,
      tableType: 'vertical',
      groupBy: 'REGION'
    },
    styles: {
      leftColWidth: 150
    },
    filters: [6, 7, 8, 9, 10, 11],
    columnSelection: 15,
    headerColumn: {
      name: 'CALENDAR_DATE',
      displayName: 'Calendar Date',
      format: 'date',
      fromFormat: 'YYYY-MM-DD',
      toFormat: 'MM/DD (ddd)',
      orderType: 'normal'
    },
    additionalHeaderColumn: {
      name: 'REGION',
      displayName: 'Region',
      format: 'string',
      orderType: 'normal'
    },
    columns: {
      UNIQUE_ACTIVE_USERS: {
        displayName: 'Active Riders',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_UNIQUE_ACTIVE_USERS',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_UNIQUE_ACTIVE_USERS',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      UNIQUE_USER_SIGNUPS: {
        displayName: 'Number of Signups',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_UNIQUE_USER_SIGNUPS',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_UNIQUE_USER_SIGNUPS',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      UNIQUE_RIDER_FIRST_TRIPS: {
        displayName: 'Number of First Trips',
        format: 'number',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_UNIQUE_RIDER_FIRST_TRIPS',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_UNIQUE_RIDER_FIRST_TRIPS',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      TRIPS_PER_RIDER: {
        displayName: 'Trips Per Rider',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_TRIPS_PER_RIDER',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_TRIPS_PER_RIDER',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      AVG_TRIP_RATINGS: {
        displayName: 'Avg. Trip Star Rating',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_AVG_TRIP_RATINGS',
          displayName: 'Avg. Riders Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_AVG_TRIP_RATINGS',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      }
    },
    value: []
  }, {
    x: 1,
    y: 108,
    w: 19,
    h: 23,
    i: 4,
    metadata: {
      name: 'juicerMetricTable',
      title: 'Juicer Metric Table',
      type: 'table-by-value',
      customField: false,
      tableType: 'vertical',
      groupBy: 'REGION'
    },
    styles: {
      leftColWidth: 150
    },
    filters: [5, 6, 7, 8, 10],
    columnSelection: 16,
    headerColumn: {
      name: 'CALENDAR_DATE',
      displayName: 'Calendar Date',
      format: 'date',
      fromFormat: 'YYYY-MM-DD',
      toFormat: 'MM/DD (ddd)',
      orderType: 'normal'
    },
    additionalHeaderColumn: {
      name: 'REGION',
      displayName: 'Region',
      format: 'string',
      orderType: 'normal'
    },
    columns: {
      PAYOUT_PER_TRIP: {
        displayName: 'Juicer Payout Per Trip',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_PAYOUT_PER_TRIP',
          displayName: 'Avg. Juicer Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_PAYOUT_PER_TRIP',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      PAYOUT_PER_CHARGE: {
        displayName: 'Avg. Juicer Payout Per Charge Task',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_PAYOUT_PER_CHARGE',
          displayName: 'Avg. Juicer Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_PAYOUT_PER_CHARGE',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      },
      PAYOUT_PER_RETRIEVAL: {
        displayName: 'Avg. Juicer Payout Per Retrieval Task',
        format: 'decimal',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_PAYOUT_PER_RETRIEVAL',
          displayName: 'Avg. Juicer Metrics - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_PAYOUT_PER_RETRIEVAL',
          valueRange: [-5, 5],
          colorRange: ['AE123A', '24593D']
        }
      }
    },
    value: []
  }, {
    x: 20,
    y: 0,
    w: 4,
    h: 6,
    i: 5,
    metadata: {
      name: 'PERIOD',
      title: 'Period',
      type: 'select',
      customField: false
    },
    query: 'SELECT DISTINCT PERIOD FROM PRODUCTION_DATA.DM.LOCAL_OPS_MERGED_2_2 ORDER BY PERIOD ASC',
    value: 'Weekly',
    options: []
  }, {
    x: 20,
    y: 6,
    w: 4,
    h: 6,
    i: 6,
    metadata: {
      name: 'CORE_REGION',
      title: 'Core Region',
      type: 'select-multiple',
      customField: false
    },
    query: 'SELECT DISTINCT CORE_REGION FROM PRODUCTION_DATA.DM.LOCAL_OPS_MERGED_2_2 WHERE MEGAREGION = \'WEU-ROW\' AND CORE_REGION IS NOT NULL ORDER BY CORE_REGION ASC',
    value: ['Fr-Benelux', 'Nordics', 'UKI'],
    options: []
  }, {
    x: 20,
    y: 12,
    w: 4,
    h: 6,
    i: 7,
    metadata: {
      name: 'COUNTRY',
      title: 'Country',
      type: 'select-multiple',
      customField: false
    },
    query: 'SELECT DISTINCT COUNTRY FROM PRODUCTION_DATA.DM.LOCAL_OPS_MERGED_2_2 WHERE CORE_REGION IN (\'Fr-Benelux\', \'Nordics\', \'UKI\') ORDER BY COUNTRY ASC',
    value: ['Belgium', 'Denmark', 'Finland', 'France', 'Norway', 'Sweden', 'United Kingdom'],
    options: []
  }, {
    x: 20,
    y: 18,
    w: 4,
    h: 6,
    i: 8,
    metadata: {
      name: 'REGION',
      title: 'Region',
      type: 'select-multiple',
      customField: false
    },
    query: 'SELECT DISTINCT REGION FROM PRODUCTION_DATA.DM.LOCAL_OPS_MERGED_2_2 WHERE COUNTRY IN (\'Belgium\', \'Denmark\', \'Finland\', \'France\', \'Norway\', \'Sweden\', \'United Kingdom\') ORDER BY REGION ASC',
    value: ['Antwerp', 'Bordeaux', 'Brussels', 'Copenhagen', 'Gothenburg', 'Helsingborg', 'Helsinki', 'Liege', 'Lille', 'London', 'Lyon', 'Malmo', 'Marseille', 'Milton Keynes', 'Montpellier', 'Namur', 'Nantes', 'Nice', 'Oslo', 'Paris', 'Reims', 'Rennes', 'Stockholm', 'Strasbourg', 'Toulouse', 'Uppsala'],
    options: []
  }, {
    x: 20,
    y: 24,
    w: 4,
    h: 6,
    i: 9,
    metadata: {
      name: 'NUMBER_FILTER',
      title: '# of Periods',
      type: 'input-number',
      customField: true
    },
    value: 8
  }, {
    x: 20,
    y: 30,
    w: 4,
    h: 6,
    i: 10,
    metadata: {
      name: 'PRODUCT',
      title: 'Product',
      type: 'select',
      customField: false
    },
    query: 'SELECT DISTINCT PRODUCT FROM PRODUCTION_DATA.DM.LOCAL_OPS_MERGED_2_2 ORDER BY PRODUCT ASC',
    value: 'All Products',
    options: []
  }, {
    x: 20,
    y: 36,
    w: 4,
    h: 2,
    i: 11,
    metadata: {
      type: 'text',
      customField: true
    },
    styles: {
      fontWeight: 'bold'
    },
    value: 'All % metrics are multipled by 100'
  }, {
    x: 1,
    y: 0,
    w: 8,
    h: 2,
    i: 12,
    metadata: {
      name: 'growthMetricsSelector',
      title: 'Growth Metrics Selector',
      type: 'select',
      customField: true,
      hideLabel: true
    },
    value: 'COMPLETED_TRIPS',
    options: [{
      name: 'Trips',
      value: 'COMPLETED_TRIPS'
    }, {
      name: 'Total Gross Bookings',
      value: 'GROSS_REVENUE'
    }, {
      name: 'Total Charges to Riders',
      value: 'RECEIPT_REVENUE'
    }, {
      name: 'Refund as % Gross Bookings',
      value: 'REFUND_OF_GROSS_REVENUE'
    }, {
      name: 'Referral Promotions Spend',
      value: 'REFERRAL_PROMOTION'
    }, {
      name: 'Referral Promotions as % Gross Bookings',
      value: 'REFERRAL_OF_GROSS_REVENUE'
    }, {
      name: 'Lifecycle Promotions Spend',
      value: 'LIFECYCLE_PROMOTION'
    }, {
      name: 'Lifecycle Promotions as % Gross Bookings',
      value: 'LIFECYCLE_OF_GROSS_REVENUE'
    }, {
      name: 'Self-serve Promotions Spend',
      value: 'SELF_SERVE_PROMOTION'
    }, {
      name: 'Self-serve Promotions as % Gross Bookings',
      value: 'SELF_SERVE_OF_GROSS_REVENUE'
    }, {
      name: 'Failed Payment as % Gross Bookings',
      value: 'UNCOLLECTED_OF_GROSS_REVENUE'
    }]
  }, {
    x: 1,
    y: 26,
    w: 8,
    h: 2,
    i: 13,
    metadata: {
      name: 'ultilizationMetricsSelector',
      title: 'Ultilization Metrics Selector',
      type: 'select',
      customField: true,
      hideLabel: true
    },
    value: 'TVD',
    options: [{
      name: 'TVD',
      value: 'TVD'
    }, {
      name: 'RPT',
      value: 'RPT'
    }, {
      name: 'Median Trip Time (in minutes)',
      value: 'MEDIAN_DURATION_IN_MINS'
    }, {
      name: 'Median Trip Distance (in miles)',
      value: 'MEDIAN_DISTANCE_IN_MILES'
    }, {
      name: 'RVD',
      value: 'RVD'
    }, {
      name: 'Zero Rate',
      value: 'ZERO_RATE'
    }]
  }, {
    x: 1,
    y: 52,
    w: 8,
    h: 2,
    i: 14,
    metadata: {
      name: 'fleetHealthMetricsSelector',
      title: 'Fleet Health Metrics Selector',
      type: 'select',
      customField: true,
      hideLabel: true
    },
    value: 'OPERATIONAL_VEHICLES',
    options: [{
      name: 'Decay Rate',
      value: 'OPS_DECAY_RATE'
    }, {
      name: 'Ops Decay Rate',
      value: 'NET_OPS_DECAY_RATE'
    }, {
      name: 'Sick Rate',
      value: 'SICK_RATE'
    }, {
      name: 'Total Vehicle Count',
      value: 'CUMULATIVE_NET'
    }, {
      name: 'Operational Vehicles',
      value: 'OPERATIONAL_VEHICLES'
    }, {
      name: 'SJ/SZ',
      value: 'OPERATIONAL_SJ_SZ'
    }, {
      name: '# of Sick Vehicles',
      value: 'SICK'
    }, {
      name: '# of Decayed Vehicles',
      value: 'DECAYED'
    }, {
      name: '# of Ops Revived Vehicles',
      value: 'OPS_REVIVED'
    }]
  }, {
    x: 1,
    y: 78,
    w: 8,
    h: 2,
    i: 15,
    metadata: {
      name: 'riderMetricsSelector',
      title: 'Rider Metrics Selector',
      type: 'select',
      customField: true,
      hideLabel: true
    },
    value: 'UNIQUE_ACTIVE_USERS',
    options: [{
      name: 'Active Riders',
      value: 'UNIQUE_ACTIVE_USERS'
    }, {
      name: 'Number of Signups',
      value: 'UNIQUE_USER_SIGNUPS'
    }, {
      name: 'Number of First Trips',
      value: 'UNIQUE_RIDER_FIRST_TRIPS'
    }, {
      name: 'Trips Per Rider',
      value: 'TRIPS_PER_RIDER'
    }, {
      name: 'Avg. Trip Star Rating',
      value: 'AVG_TRIP_RATINGS'
    }]
  }, {
    x: 1,
    y: 104,
    w: 8,
    h: 2,
    i: 16,
    metadata: {
      name: 'juicerMetricsSelector',
      title: 'Juicer Metrics Selector',
      type: 'select',
      customField: true,
      hideLabel: true
    },
    value: 'PAYOUT_PER_TRIP',
    options: [{
      name: 'Juicer Payout Per Trip',
      value: 'PAYOUT_PER_TRIP'
    }, {
      name: 'Avg. Juicer Payout Per Charge Task',
      value: 'PAYOUT_PER_CHARGE'
    }, {
      name: 'Avg. Juicer Payout Per Retrieval Task',
      value: 'PAYOUT_PER_RETRIEVAL'
    }]
  }, {
    x: 0,
    y: 0,
    w: 1,
    h: 25,
    i: 17,
    metadata: {
      type: 'text',
      customField: true
    },
    styles: {
      backgroundColor: 'rgb(230,236,240)',
      writingMode: 'tb-rl',
      fontWeight: 'bold',
      fontSize: '20px',
      transform: 'rotate(-180deg)',
      height: '100%',
      width: '100%',
      textAlign: 'center',
      padding: '25%'
    },
    value: 'Growth'
  }, {
    x: 0,
    y: 27,
    w: 1,
    h: 25,
    i: 18,
    metadata: {
      type: 'text',
      customField: true
    },
    styles: {
      backgroundColor: 'rgb(245, 234, 215)',
      writingMode: 'tb-rl',
      fontWeight: 'bold',
      fontSize: '20px',
      transform: 'rotate(-180deg)',
      height: '100%',
      width: '100%',
      textAlign: 'center',
      padding: '25%'
    },
    value: 'Utilization'
  }, {
    x: 0,
    y: 54,
    w: 1,
    h: 25,
    i: 19,
    metadata: {
      type: 'text',
      customField: true
    },
    styles: {
      backgroundColor: 'rgb(232, 237, 218)',
      writingMode: 'tb-rl',
      fontWeight: 'bold',
      fontSize: '20px',
      transform: 'rotate(-180deg)',
      height: '100%',
      width: '100%',
      textAlign: 'center',
      padding: '25%'
    },
    value: 'Fleet Health'
  }, {
    x: 0,
    y: 81,
    w: 1,
    h: 25,
    i: 20,
    metadata: {
      type: 'text',
      customField: true
    },
    styles: {
      backgroundColor: 'rgb(243, 235, 243)',
      writingMode: 'tb-rl',
      fontWeight: 'bold',
      fontSize: '20px',
      transform: 'rotate(-180deg)',
      height: '100%',
      width: '100%',
      textAlign: 'center',
      padding: '25%'
    },
    value: 'Riders'
  }, {
    x: 0,
    y: 108,
    w: 1,
    h: 25,
    i: 21,
    metadata: {
      type: 'text',
      customField: true
    },
    styles: {
      backgroundColor: 'rgb(223, 231, 232)',
      writingMode: 'tb-rl',
      fontWeight: 'bold',
      fontSize: '20px',
      transform: 'rotate(-180deg)',
      height: '100%',
      width: '100%',
      textAlign: 'center',
      padding: '25%'
    },
    value: 'Juicer'
  }, {
    x: 0,
    y: 25,
    w: 20,
    h: 1,
    i: 22,
    metadata: {
      type: 'blank',
      customField: true
    }
  }, {
    x: 0,
    y: 50,
    w: 20,
    h: 1,
    i: 23,
    metadata: {
      type: 'blank',
      customField: true
    }
  }, {
    x: 0,
    y: 75,
    w: 20,
    h: 1,
    i: 24,
    metadata: {
      type: 'blank',
      customField: true
    }
  }, {
    x: 0,
    y: 100,
    w: 20,
    h: 1,
    i: 25,
    metadata: {
      type: 'blank',
      customField: true
    }
  }, {
    x: 1,
    y: 130,
    w: 8,
    h: 2,
    i: 26,
    metadata: {
      name: 'bottomlineMetricsSelector',
      title: 'Bottomline Metrics Selector',
      type: 'select',
      customField: true,
      hideLabel: true
    },
    value: 'NET_DEPRECIATION',
    options: [{
      name: 'Net Depreciation',
      value: 'NET_DEPRECIATION'
    }, {
      name: 'Net Depreciation % GB',
      value: 'NET_DEPRECIATION_PCT_GROSS'
    }, {
      name: 'Juicer Labor Cost',
      value: 'JUICER_LABOR_COST'
    }, {
      name: 'Juicer Labor Cost % GB',
      value: 'JUICER_LABOR_COST_PCT_GROSS'
    }, {
      name: 'Local Ops Labor Cost',
      value: 'LOCAL_OPS_PAYOUT'
    }, {
      name: 'Local Ops Labor Cost % GB',
      value: 'LOCAL_OPS_PAYOUT_PCT_GROSS'
    }]
  }, {
    x: 1,
    y: 131,
    w: 19,
    h: 23,
    i: 27,
    metadata: {
      name: 'bottomlineMetricTable',
      title: 'Bottomline Metric Table',
      type: 'table-by-value',
      customField: false,
      tableType: 'vertical',
      groupBy: 'REGION'
    },
    styles: {
      leftColWidth: 150
    },
    filters: [5, 6, 7, 8, 10],
    columnSelection: 26,
    headerColumn: {
      name: 'CALENDAR_DATE',
      displayName: 'Calendar Date',
      format: 'date',
      fromFormat: 'YYYY-MM-DD',
      toFormat: 'MM/DD (ddd)',
      orderType: 'normal'
    },
    additionalHeaderColumn: {
      name: 'REGION',
      displayName: 'Region',
      format: 'string',
      orderType: 'normal'
    },
    columns: {
      NET_DEPRECIATION: {
        displayName: 'Net Depreciation',
        format: 'currency',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_NET_DEPRECIATION',
          displayName: 'Net Depreciation - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_NET_DEPRECIATION',
          valueRange: [-5, 5],
          colorRange: ['24593D', 'AE123A']
        }
      },
      NET_DEPRECIATION_PCT_GROSS: {
        displayName: 'Net Depreciation % GB',
        format: 'percentage',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_NET_DEPRECIATION_PCT_GROSS',
          displayName: 'Net Depreciation % GB - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_NET_DEPRECIATION_PCT_GROSS',
          valueRange: [-5, 5],
          colorRange: ['24593D', 'AE123A']
        }
      },
      JUICER_LABOR_COST: {
        displayName: 'Juicer Labor Cost',
        format: 'currency',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_JUICER_LABOR_COST',
          displayName: 'Juicer Labor Cost - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_JUICER_LABOR_COST',
          valueRange: [-5, 5],
          colorRange: ['24593D', 'AE123A']
        }
      },
      JUICER_LABOR_COST_PCT_GROSS: {
        displayName: 'Juicer Labor Cost % GB',
        format: 'percentage',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_JUICER_LABOR_COST_PCT_GROSS',
          displayName: 'Juicer Labor Cost % GB - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_JUICER_LABOR_COST_PCT_GROSS',
          valueRange: [-5, 5],
          colorRange: ['24593D', 'AE123A']
        }
      },
      LOCAL_OPS_PAYOUT: {
        displayName: 'Local Ops Payout',
        format: 'currency',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_LOCAL_OPS_PAYOUT',
          displayName: 'Local Ops Payout - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_LOCAL_OPS_PAYOUT',
          valueRange: [-5, 5],
          colorRange: ['24593D', 'AE123A']
        }
      },
      LOCAL_OPS_PAYOUT_PCT_GROSS: {
        displayName: 'Local Ops Payout % GB',
        format: 'percentage',
        orderType: 'normal',
        tooltip: [{
          column: 'WOW_LOCAL_OPS_PAYOUT_PCT_GROSS',
          displayName: 'Local Ops Payout - WOW',
          format: 'percentage'
        }],
        background: {
          comparedColumn: 'WOW_LOCAL_OPS_PAYOUT_PCT_GROSS',
          valueRange: [-5, 5],
          colorRange: ['24593D', 'AE123A']
        }
      }
    },
    value: []
  }, {
    x: 0,
    y: 130,
    w: 1,
    h: 25,
    i: 28,
    metadata: {
      type: 'text',
      customField: true
    },
    styles: {
      backgroundColor: 'rgb(239, 235, 232)',
      writingMode: 'tb-rl',
      fontWeight: 'bold',
      fontSize: '20px',
      transform: 'rotate(-180deg)',
      height: '100%',
      width: '100%',
      textAlign: 'center',
      padding: '25%'
    },
    value: 'Bottomline'
  }, {
    x: 0,
    y: 125,
    w: 20,
    h: 1,
    i: 29,
    metadata: {
      type: 'blank',
      customField: true
    }
  }, {
    x: 20,
    y: 40,
    w: 4,
    h: 2,
    i: 30,
    metadata: {
      type: 'report',
      customField: true
    }
  }, {
    x: 20,
    y: 38,
    w: 4,
    h: 4,
    i: 31,
    metadata: {
      type: 'blank',
      customField: true
    }
  }, {
    x: 20,
    y: 6,
    w: 4,
    h: 6,
    i: 32,
    metadata: {
      name: 'MEGAREGION',
      title: 'Megaregion',
      type: 'select-multiple',
      customField: false
    },
    query: 'SELECT DISTINCT MEGAREGION FROM PRODUCTION_DATA.DM.LOCAL_OPS_MERGED_2_2 WHERE MEGAREGION IS NOT NULL ORDER BY MEGAREGION ASC',
    value: ['WEU-ROW'],
    options: []
  }, {
    x: 20,
    y: 42,
    w: 4,
    h: 4,
    i: 33,
    metadata: {
      type: 'blank',
      customField: true
    }
  }, {
    x: 20,
    y: 46,
    w: 4,
    h: 3,
    i: 34,
    metadata: {
      type: 'text',
      customField: true
    },
    value: 'We\'re now experiencing new region mapping transition. And Core Regions: <b>EU South</b>, <b>EU North</b>, <b>EU East</b> or <b>APAC</b> will be changed to Megaregion. For the transition period, if you want to find the UE data for these previous Core Regions, please note that we no longer offer core region level data after the week of 12/02/2019. For full data, please use the aggregation of Megaregion.'
  }]
}
</script>
